import { Component } from 'react';
import DataTable from 'Container/DataTable/DataTableContainer';
import Pagination from 'Components/Pagination/index';
import formUrlParams from 'Helpers/urlform'
import { Link } from 'react-router-dom';
import SendMessage from 'Container/Groups/SendMessageContainer';
import Image from 'Components/Common/Image';
import { CSVLink } from 'react-csv';
import dateFormat from 'dateformat';
import {  convertUTCTOLocalTimeStamp } from 'Components/Common/TimeStamp';
import { tableConstants } from 'Constants';

export default class Groups extends Component {
  constructor(props) {
    super(props);
    const model = {
      headers : [
        {
          className: tableConstants.SMALL_GRID_NAME_WIDTH,
          title: 'Group Name',
          accessor: 'groupName' /* API response */,
          chooseOption: {
            name: 'groupNameSearch', /* API param name */
            // Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          combineapidata: [ 'groupName', 'groupImage' ],
          cell: (rowDetails)=>{
            const { index, content, ...rest } = rowDetails;
            return(
            <td key={ index } className={ tableConstants.SMALL_GRID_NAME_WIDTH }>
               {/* <div className='user'>
                  <Image imageToken={ rest.groupImage } isGroup={ true } />
                  <Link to={ `/groupinfo/${ rest.groupId }` } > { content } </Link>
                </div> */}
                <div className='ctUserInfo'>
                  <div className='ctUserInfo_img'>
                    <Image imageToken={ rest.groupImage } isGroup={ true } />
                  </div>
                  <div className="data_tooltip" tooltip={ content }><span className='ctUserInfo_name text_ellipsis'><Link to={ `/groupinfo/${ rest.groupId }` } > { content } </Link></span></div>
                </div>
            </td>
            )            
          },
          sortOption: true,
        },
        {
          className: tableConstants.SMALL_GRID_NAME_WIDTH,
          title: 'Created By',
          // chooseOption: {
          //   name: 'createdBySearch', /* API param name */
          //   Component: 'Search',
          //   dispatchFunction: this.handleSearch
          // },
          accessor: 'createdBy' /* API response */,
          sortOption: true,
          isDataEncrypted: true,
          tooltip: true
        },
        {
          className:tableConstants.DATE_RANGE_WIDTH,
          title: 'Created Date',
          chooseOption: {
            name: 'createdDateSearch',
            Component: 'DateTimeRangeComponent',
            dispatchFunction: this.handleDateSearch
          },
          cell: function (rowDetails) {
            const { index, content } = rowDetails;
            const val = content && content.replace('T',' ')
            const time = content && convertUTCTOLocalTimeStamp(val)
            return (
              <td key={ index } className={ tableConstants.DATE_RANGE_WIDTH }>
                {content && dateFormat(time, 'mmm d, yyyy / hh:MM:ss TT ')}
              </td>
            );
          },
          accessor: 'createdAt',
          sortOption: true,
        },
        {
          className:tableConstants.DEFAULT_WIDTH,
          title: 'Admin Users',
          accessor:'adminUsers',
        },
        {
          title: 'Total Members',
          accessor: 'totalMembers',
        },
        /* {
          title: 'Action',
          accessor: 'id',
          cell: (rowDetail) => {
            const { index, id, rowIdx, profile, ...rest } = rowDetail;
            const permission = profile && profile.Team;
            return (
              <td key={ index } data-row={ rowIdx } className='action-new'>
                <button className='btn btn_primary' onClick={ (e) => this.sendMessage( rest ) }>Send Message</button>
              </td>
            );
          },
        }, */
      ],
      sendMessageForm: false,
      activeEditData: '',
      filtered: [],
      responseArray: [],
      pageLimit: 10,
      initialPage: 1,
      activeSort: { id: 'createdAtSort', value: 'desc' },
    }
    this.state = model;
  }

  componentDidMount(){
    let browserBackClick = false;
    window.onpopstate = (e)=> {
        const location = e.target.location;
        if(location.pathname === '/groups'){
            browserBackClick = true;
        }
    }
    setTimeout(() => {
        if (!browserBackClick) {
          const updatedFilter = [ this.state.activeSort ];
          this.props.fetchGroups(updatedFilter);
          this.props.exportGroup(updatedFilter);
        }
    }, 50);
  }

  formUrlParams = (name, value, rest) => {
    const { filtered, activeSort } = this.state;
    const filterResponse = formUrlParams(filtered, name, value);
    this.setState({ filtered: filterResponse, ...rest }, () => {
      let updatedFilter = this.state.filtered;
      if(activeSort && activeSort.id){
        updatedFilter = [
          ...this.state.filtered,
          activeSort
        ]
      }
      this.props.fetchGroups(updatedFilter);
      this.props.exportGroup(updatedFilter);
    });
  }

  /**
   * @method sortTable
   * @summary sort for view data
   * @param {name} sortAttribite - Query string name
   * @return { function } formUrlSort
   */
  sortTable = (sortAttribite) => {
    const { activeSort } = this.state
    const sortType = (activeSort.id === sortAttribite) ? 
    ((activeSort.value && activeSort.value == 'desc') ? 'asc' : 'desc') : 'asc';
    this.setState({
      activeSort: { id: sortAttribite, value: sortType },
    }, () => {
      this.formUrlSort();
    })
  }

  /**
   * @method formUrlSort
   * @summary Construct the query string based on user selection
   * @return {function} call fetch admin user api after change local state
   */
  formUrlSort = () => {
    const updatedFilter = [
      ...this.state.filtered,
      this.state.activeSort
    ]
    this.props.fetchGroups(updatedFilter);
    this.props.exportGroup(updatedFilter);
  }
  
  handleDateSearch = (data) => {
    for (const [ key, value ] of Object.entries(data)) {
      this.formUrlParams(key, value);
    }
  };

  handleSearch = (event) => {
    const { name, value } = event.target;
    this.formUrlParams(name, value)
  }

  setPageLimit = ( name, value ) => {
    this.formUrlParams(name, value,{ pageLimit: value })
  }

  sendMessage = (data) => {
    this.setState({ activeEditData: data, sendMessageForm: true })
  }

  /**
   * @method closeForm
   * @summary close send message form
   * @return { object } updated domain state
   */
  closeForm = () => {
    this.setState({ sendMessageForm: false });
  };

  render() {
    const { Groups, totalRecords, currentPage, loading, exportGroupData } = this.props;
    const { sendMessageForm, pageLimit } = this.state;
    return (
      <>
          <div className='grid pageContainer_inner'>
            <div className='heading-block gap-10'>
              <div className='block_flex'><h4>Groups</h4></div>
              <div className='block_flex'>
                { exportGroupData && exportGroupData.length !== 0 && <CSVLink
                    data = { exportGroupData }
                    filename = { 'Group Details.csv' }
                    className = 'btn btn_green'
                    onClick={ () => {
                      console.log('Export Data'); // Your click handling logic
                    } }
                  >
                    Export To CSV
                  </CSVLink>
                }

                {sendMessageForm && (
                  <SendMessage
                    closeForm={ this.closeForm }
                    { ...this.state.activeEditData }
                  />
                )}
              </div>
            </div>
            <div className='responsive-table ctTableBox'>
              <DataTable 
                className="data-table"
                tableClassName ='col-s'
                keyField="id"
                width="100%"
                pagination={ {
                    enabled: true,
                    pageLength: 5,
                    type: 'long'
                } }
                headers={ this.state.headers }
                data={ Groups }
                noData="No records!" 
                loading={ loading }
                sortTable={ this.sortTable }
                activeSort={ this.state.activeSort }
              />
              <Pagination
                handleClick={ this.formUrlParams }
                totalRecords={ totalRecords }
                initialPage={ currentPage }
                setPageLimit={ this.setPageLimit }
                pageLimit={ pageLimit }
                updateActiveQuery={ this.updateActiveQuery }
              />
            </div>            
          </div>
      </>
    );
  }
}
